function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Inner"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union",
  d: "M3.73639 6.86133L9.38889 12.0807L15.0414 6.86133L16.7778 8.46817L9.38889 15.3058L2 8.46817L3.73639 6.86133Z",
  fill: "currentColor "
}));

const SvgInner = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 19 19",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Inner.670b7f1a.svg";
export { ForwardRef as ReactComponent };